/*
 * Copyright (c) 2026 Cloudcharge AB.
 * All Rights Reserved.
 */

const PLACEHOLDER_ORIGIN = 'https://portal.invalid';

// eslint-disable-next-line no-control-regex
const CONTROL_CHARACTERS = /[\u0000-\u001F\u007F]/;

/**
 * Returns `redirect` when it is a relative path inside the portal, otherwise `/`.
 *
 * Only a path starting with a single `/` is accepted: `//host` and `/\host` are protocol-relative
 * to a browser, a scheme (`javascript:`, `https:`) leaves the portal, and browsers drop tabs and
 * newlines from urls, so `/\t/host` would become `//host`. Backslashes and control characters are
 * therefore rejected anywhere in the value.
 */
export function safeRedirectPath(redirect: string | null | undefined): string {
    if (!redirect || !redirect.startsWith('/')) return '/';
    if (redirect.startsWith('//')) return '/';
    if (redirect.includes('\\') || CONTROL_CHARACTERS.test(redirect)) return '/';
    try {
        if (new URL(redirect, PLACEHOLDER_ORIGIN).origin !== PLACEHOLDER_ORIGIN) return '/';
    } catch {
        return '/';
    }
    return redirect;
}
